import { createApiOperation } from "../api-client/create-api-operation";

import { Prices as PricesType } from "./types/prices";

export const Prices = {
  getRegion: createApiOperation<PricesType, "/Api/Prices/{regionId}", "get">(
    "/Api/Prices/{regionId}",
    "get",
  ),
  delete: createApiOperation<
    never,
    "/Api/Prices/{regionId}/{productId}",
    "delete"
  >("/Api/Prices/{regionId}/{productId}", "delete"),
  exportByDataset: createApiOperation<
    never,
    "/Api/Prices/{regionId}/Dataset/{datasetId}/Export",
    "get"
  >("/Api/Prices/{regionId}/Dataset/{datasetId}/Export", "get", { file: true }),
};
